module.exports = __webpack_public_path__ + "img/advanced.f02e91b0.svg";